module.exports = __webpack_public_path__ + "close-icon.svg?742ae31d2cda2130550a85713dd3ce2d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close-icon.svg
// module id = 190
// module chunks = 0